import { render } from "./PartnerPersonalData.vue?vue&type=template&id=65d1e190&scoped=true"
import script from "./PartnerPersonalData.vue?vue&type=script&lang=js"
export * from "./PartnerPersonalData.vue?vue&type=script&lang=js"

import "./PartnerPersonalData.vue?vue&type=style&index=0&id=65d1e190&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d1e190"]])

export default __exports__